<h2 class="section__title">Award</h2>
<p>
  Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium neque
  ipsam exercitationem culpa ut tempore fugiat sunt in, laudantium quod
  facilis dolorum architecto enim cupiditate eaque ducimus distinctio quo
  reiciendis autem ipsa eveniet possimus eum. Dolore et soluta, porro nisi
  voluptatum voluptates maxime aspernatur sed corrupti, itaque tempora odio
  laboriosam assumenda deserunt eligendi, dolor nesciunt saepe tempore eos
  consequuntur rem exercitationem laborum delectus.
</p>